isUserGiftCompatible